import axios from "axios";

const jwtAxios = axios.create({
  // baseURL: process.env.REACT_APP_ECOM_API_BASE_URL, // YOUR_API_URL HERE
  baseURL: process.env.REACT_APP_ECOM_API_BASE_URL, // YOUR_API_URL HERE
  // baseURL: "https://staging-et01.jinoteco.se/api/v1/", // YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json",
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.data.msg === "Token is not valid") {
      console.log("Need to logout user");
      // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
  }
);
export const setAuthToken = (token: string | null) => {
  if (token) {
    jwtAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    sessionStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['Authorization'];
    sessionStorage.removeItem('token');
  }
};

export default jwtAxios;
